/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

import "regenerator-runtime/runtime"
import "./src/styles/global.css"
import posthog from "./src/utils/posthog"
require("prismjs/themes/prism-okaidia.css")

export const onRouteUpdate = ({ location }) => {
  posthog.capture("$pageview")
}

// Redirect any unmatched routes to home page
export const onPreRouteUpdate = ({ location, prevLocation }) => {
  // List of valid paths that should not be redirected
  const validPaths = ['/', '/404/', '/404.html']
  
  // If the current path is not in our valid paths and it's not a known Gatsby path
  if (!validPaths.includes(location.pathname) && 
      !location.pathname.startsWith('/__') && // Gatsby dev paths
      !location.pathname.startsWith('/static/') && // Static assets
      location.pathname !== prevLocation?.pathname) {
    
    // Use window.location.replace for immediate redirect
    if (typeof window !== 'undefined') {
      window.location.replace('/')
    }
  }
}
